import React, { useState } from "react";
import "./PopupSession.scss";
import { createSession } from "../../api/sessionService";
import { toast } from "react-hot-toast";
import { fetchDashboardData } from "../../redux/actions/dashboardActions";
import { useDispatch } from "react-redux";
import { MdRestore } from "react-icons/md";


const PopupSession = ({ dashboardData, onClose }) => {
  const dispatch = useDispatch();

  // Estados
  const [csvFile, setCsvFile] = useState(null);
  const [selectedDataSource, setSelectedDataSource] = useState("");
  const [selectedChampionship, setSelectedChampionship] = useState("");
  const [selectedType, setSelectedType] = useState("");
  const [selectedRacetrack, setSelectedRacetrack] = useState("");
  const [driver, setDriver] = useState("");

  // Opciones
  const optionChampion = dashboardData?.championships || [];
  const optionRacetrack = dashboardData?.racetracks || [];
  const optionType = dashboardData?.session_types || [];

  let optionDataSource = [];
  if (
    dashboardData &&
    dashboardData.user &&
    Array.isArray(dashboardData.user.data_sources)
  ) {
    optionDataSource = dashboardData.user.data_sources.map(
      (dataSource) => dataSource.vehicle_name,
    );
  }

  // Handlers
  const handleFileChange = (event) => {
    setCsvFile(event.target.files[0]);
  };

  const handleChange = (setter) => (event) => {
    setter(event.target.value);
  };

  const handleRestoreConfig = () => {
    const savedConfig = JSON.parse(localStorage.getItem("popupSessionConfig"));
    if (savedConfig) {
      setSelectedDataSource(savedConfig.selectedDataSource || "");
      setSelectedChampionship(savedConfig.selectedChampionship || "");
      setSelectedType(savedConfig.selectedType || "");
      setSelectedRacetrack(savedConfig.selectedRacetrack || "");
      setDriver(savedConfig.driver || "");
      toast.success("Previous configuration restored.", { position: "top-center" });
    } else {
      toast.error("No previous configuration found.", { position: "top-center" });
    }
  };

  const onUpload = async () => {
    if (!csvFile) {
      toast.error("Please select a CSV file.", { position: "top-center" });
      return;
    }
    if (!selectedDataSource) {
      toast.error("Please select a Data Source.", { position: "top-center" });
      return;
    }
    if (!selectedChampionship) {
      toast.error("Please select a Championship.", { position: "top-center" });
      return;
    }
    if (!selectedType) {
      toast.error("Please select a Type.", { position: "top-center" });
      return;
    }
    if (!selectedRacetrack) {
      toast.error("Please select a Racetrack.", { position: "top-center" });
      return;
    }

    // Buscamos el objeto data_source completo a partir de su vehicle_name
    const [matchingDataSource] = dashboardData.user.data_sources.filter(
      (d) => d.vehicle_name === selectedDataSource,
    );

    const metadata = {
      championship: selectedChampionship,
      data_source: {
        data_source_id: matchingDataSource._id,
        channel_names: matchingDataSource.channel_names,
        source_type: matchingDataSource.source_type,
        vehicle_name: matchingDataSource.vehicle_name,
      },
      racetrack: selectedRacetrack,
      session_type: selectedType,
      driver: driver,
    };

    let toastId = toast.loading("Loading...", {
      position: "top-center"
    });
    try {
      const response = await createSession(csvFile, metadata);

      // Save current config to localStorage
      const configToSave = {
        selectedDataSource,
        selectedChampionship,
        selectedType,
        selectedRacetrack,
        driver,
      };
      localStorage.setItem("popupSessionConfig", JSON.stringify(configToSave));

      console.log("Session created successfully:", response);
      toast.success("Session created successfully", { position: "top-center" });
      // Refrescamos datos del dashboard
      dispatch(fetchDashboardData());
      // onClose();
      toast.remove(toastId);
    } catch (error) {
      toast.remove(toastId)
      let eDetail = JSON.stringify(error.response.data.detail);
      toast.error(eDetail.replace('"','').replace('"',''), {
        position: "top-center",
        removeDelay: 500
      });
      
    } 
  };

  return (
    <div className="popup">
      <div className="popup-content popup-sessions">
        <div className="tit-popup">
          <h2>Add session</h2>
        </div>

        <div>
          <div className="file-container">
            <span className="fixed-text">Select File</span>
            <div>
              <input
                className="search-popup-session"
                type="file"
                onChange={handleFileChange}
                placeholder="C:/User/Downloads/Oschersleben_19092023.csv"
              />
            </div>
          </div>

          <div className="parameters">
            <h3>Parameters</h3>
            <div className="cont-btn">
              <button className="btn btn-icon" onClick={handleRestoreConfig} title="Load last config">
                <MdRestore size={22}/>
              </button>
            </div>
          </div>

          <div className="custom-select">
            <div>
              <div className="select-container reference-lap-add">
                <span>Data Source</span>
                <select
                  value={selectedDataSource}
                  onChange={handleChange(setSelectedDataSource)}
                >
                  <option value="">Select a Data Source</option>
                  {optionDataSource.map((option) => (
                    <option key={option} value={option}>
                      {option}
                    </option>
                  ))}
                </select>
              </div>

              <div className="select-container">
                <span>Championship</span>
                <select
                  value={selectedChampionship}
                  onChange={handleChange(setSelectedChampionship)}
                >
                  <option value="">Select a Championship</option>
                  {optionChampion.map((option) => (
                    <option key={option} value={option}>
                      {option}
                    </option>
                  ))}
                </select>
              </div>
                
              <div className="input-container">
                <span className="fixed-text">Driver (Optional)</span>
                <input
                  type="text"
                  placeholder="Driver name here..."
                  value={driver}
                  onChange={(e) => setDriver(e.target.value)}
                />
              </div>
            </div>

            <div>
              <div className="select-container">
                <span>Type</span>
                <select
                  value={selectedType}
                  onChange={handleChange(setSelectedType)}
                >
                  <option value="">Select a Type</option>
                  {optionType.map((option) => (
                    <option key={option} value={option}>
                      {option}
                    </option>
                  ))}
                </select>
              </div>

              <div className="select-container">
                <span>Racetrack</span>
                <select
                  value={selectedRacetrack}
                  onChange={handleChange(setSelectedRacetrack)}
                >
                  <option value="">Select a Racetrack</option>
                  {optionRacetrack.map((option) => (
                    <option key={option} value={option}>
                      {option}
                    </option>
                  ))}
                </select>
              </div>
              <div className="cont-btn">
                <button className="btn btn-blue" onClick={onUpload}>
                  Add
                </button>
                <button className="btn" onClick={onClose}>
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>        
      </div>
    </div>
  );
};

export default PopupSession;
